export default __webpack_public_path__ + "static/media/0x7e7ff932fab08a0af569f93ce65e7b8b23698ad8.1bd5fa98.webp";